import { render, staticRenderFns } from "./resumeRegister.vue?vue&type=template&id=05f01c29&scoped=true"
import script from "./resumeRegister.vue?vue&type=script&lang=js"
export * from "./resumeRegister.vue?vue&type=script&lang=js"
import style0 from "./resumeRegister.vue?vue&type=style&index=0&id=05f01c29&prod&lang=scss&scoped=true"
import style1 from "./resumeRegister.vue?vue&type=style&index=1&id=05f01c29&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f01c29",
  null
  
)

export default component.exports